import { combineReducers } from 'redux';
import order from './orderReducers';
import project from './projectReducers';
import quotation from './quotationReducers';
import auth from './AuthenticationReducers';
import userLst from './userReducers';
import customerLst from './customerReducers';
import tmxLst from './tmxReducers';
import languagePairs from './languagePairs';
import customerConfig from './customerConfig';
import newProjectReducers from './newProjectReducers';
import processingOrders from './processingOrdersReducers';
import search from './searchReducers';
import editor from './editorReducers';
import globalUI from './globalUIReducers';
import alerts from './alertsReducers';
import multiplataforma from './multiplataformaReducers';
import supplierConfiguration from './supplierConfigurationReducers';
import appConfig from './appConfigReducers';


const appReducer = combineReducers({
  orders: order,
  projects: project,
  users: userLst,
  customers: customerLst,
  quotations: quotation,
  user: auth,
  tmxs: tmxLst,
  languagePairs: languagePairs,
  customerConfig: customerConfig,
  newProject: newProjectReducers,
  processingOrders: processingOrders,
  globalUI: globalUI,
  search: search,
  editor: editor,
  alerts: alerts,
  multiplataforma: multiplataforma,
  supplierConfiguration: supplierConfiguration,
  appConfig: appConfig
})

const rootReducer = (state, action) => {
  if (	(action.type === 'LOGOUT') ||
		(action.type === 'LOGIN') ||
		(action.type === 'SWITCH') ||
		(action.type === 'SWITCH_LOGOUT') ) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;